import { AdminDashboardComponent } from './components/menu/admin-dashboard/admin-dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AdminComponent } from './admin.component';
import { AdminSharedFilesComponent } from './components/menu/admin-shared-files/admin-shared-files.component';
import { AdminUsersComponent } from './components/menu/admin-users/admin-users.component';
import { AdminUserPreviewComponent } from './components/admin-user-preview/admin-user-preview.component';
import { UserReportResolver } from './resolvers/user-report.resolver';
import { AdminOrdersComponent } from './components/menu/admin-orders/admin-orders.component';
import { AdminPaymentsComponent } from './components/menu/admin-payments/admin-payments.component';
import { CellarComponent } from './components/menu/cellar/cellar.component';
import { BindingResolver } from './resolvers/bindings.resolver';
import { TypingResolver } from './resolvers/typing.resolver';
import { ColorsResolver } from './resolvers/colors.resolver';
import { DeliveryMethodsComponent } from './components/delivery-methods/delivery-methods.component';
import { AdminTasksComponent } from './components/menu/admin-tasks/admin-tasks.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    // canActivate: 
    children: [
      { path: 'shared-files', component: AdminSharedFilesComponent },
      { path: 'orders-history', component: AdminOrdersComponent },
      { path: 'dashboard', component: AdminDashboardComponent },
      { path: 'carts', component: AdminPaymentsComponent },
      { path: 'users', component: AdminUsersComponent },
      { path: 'tasks', component: AdminTasksComponent },
      {
        path: 'cellar',
        component: CellarComponent,
        resolve: {
          typings: TypingResolver,
          bindings: BindingResolver,
          colors: ColorsResolver,
        },
      },
      {
        path: 'users/:id',
        component: AdminUserPreviewComponent,
        resolve: {
          userReport: UserReportResolver,
        },
      },
      {
        path: 'delivery-methods',
        component: DeliveryMethodsComponent,
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
